import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../../services/canvasUtils'; // Import de la fonction utilitaire
import { Button } from 'react-bootstrap';

/**
 * Composant de Recadrage d'Image pour respecter les dimensions cibles.
 * @param {string} imageSrc - L'URL de l'image (base64) à recadrer.
 * @param {number} targetWidth - Largeur cible (170px).
 * @param {number} targetHeight - Hauteur cible (187px).
 * @param {function} onComplete - Callback appelé avec le fichier final après recadrage.
 * @param {function} onCancel - Callback appelé si l'utilisateur annule.
 */
export default function ImageCropper({ imageSrc, targetWidth, targetHeight, onComplete, onCancel }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // Calcule le ratio cible (170/187)
  const aspect = targetWidth / targetHeight;

  // Stocke la zone recadrée en pixels pour l'exportation
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // Exporte l'image recadrée en tant que fichier (Blob) et appelle le callback
  const showCroppedImage = useCallback(async () => {
    try {
      // 1. Réaliser le recadrage/redimensionnement sur Canvas
      const croppedBlob = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        targetWidth,
        targetHeight
      );
      
      // 2. Convertir le Blob en File (nécessaire pour l'upload FormData)
      const croppedFile = new File([croppedBlob], "cropped_preco.png", { type: 'image/png' });
      
      // 3. Renvoyer le fichier final au modal parent
      onComplete(croppedFile);

    } catch (e) {
      console.error(e);
      // Gérer l'erreur de recadrage
    }
  }, [imageSrc, croppedAreaPixels, onComplete, targetWidth, targetHeight]);

  return (
    <div className="d-flex flex-column" style={{ height: '100%' }}>
        <div style={{ height: '400px', width: '100%', position: 'relative', marginBottom: '60px' }}>
            <Cropper
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                aspect={aspect}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
                restrictPosition={true} 
            />
            <div 
                style={{
                    position: 'absolute',
                    bottom: 10,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 10,
                    padding: '10px',
                    backgroundColor: 'rgba(0,0,0,0.4)',
                    borderRadius: '8px'
                }}>
                <input 
                    type="range"
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    aria-label="Zoom"
                    onChange={(e) => setZoom(e.target.value)}
                    style={{ width: '150px' }}
                />
            </div>
            
            {/* Affichage des dimensions cibles */}
            <div style={{ position: 'absolute', top: 10, left: 10, zIndex: 10, color: 'white', backgroundColor: 'rgba(0,0,0,0.5)', padding: '5px', borderRadius: '4px', fontSize: '0.9em' }}>
                Cible: {targetWidth}x{targetHeight}px (Ratio {aspect.toFixed(2)})
            </div>
            
        </div>
      
        <div className='d-flex justify-content-end pt-3 gap-2' style={{ width: '100%' }}>
            <Button variant="secondary" onClick={onCancel}>Annuler</Button>
            <Button variant="success" onClick={showCroppedImage}>Recadrer et Valider</Button>
        </div>
    </div>
  );
}